<template>
  <v-footer color="primary" padless>
    <v-row justify="center" no-gutters>
      <v-col class="primary py-4 text-center" cols="12">
        <span :title="version.concat(' - ').concat(buildtime)">©</span>
        {{ new Date().getFullYear() }} —
        <strong>Alerce</strong>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  name: "RwFooter",
  data: () => ({
    version: process.env.VUE_APP_VERSION,
    buildtime: document.documentElement.dataset.buildTimestampUtc
  })
};
</script>
